import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import FileDropzone from '../../layouts/fileDropzone'
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper'

class DropzoneField extends Component {
  static propTypes = {
    fieldProps: PropTypes.shape({
      compact: PropTypes.bool,
      multiple: PropTypes.bool,
      docUploaded: PropTypes.func,
      elmId: PropTypes.string,
      onChange: PropTypes.func,
      onDrop: PropTypes.func,
      value: PropTypes.any,
      embeddedContext: PropTypes.string,
      resources: PropTypes.arrayOf(
        PropTypes.shape({
          urn: PropTypes.string,
        })
      ),
    }).isRequired,
    showError: PropTypes.bool,
  }

  static defaultProps = {
    embeddedContext: 'browser',
  }

  state = {
    files: [],
  }

  componentDidMount() {
    const files = !this.props.fieldProps.value
      ? []
      : _.flattenDeep([this.props.fieldProps.value])
    this.setState({
      files,
    })
  }

  render() {
    const { fieldProps, showError } = this.props
    const { files } = this.state
    const { docUploaded, elmId, onChange, onDrop, value, multiple, ...rest } =
      fieldProps

    const newOnChange = data => {
      if (onChange) {
        const changeVal =
          data && Array.isArray(data) && !multiple ? data[0] : data
        onChange(changeVal || '')
        if (changeVal && changeVal.length) {
          docUploaded && docUploaded()
        }
        this.setState({
          files: data,
        })
      }
    }

    return (
      <FileDropzone
        remoteError={showError}
        onChange={newOnChange}
        files={files}
        data-elm-id={`${elmId}_drop`}
        multiple={multiple}
        {...rest}
      />
    )
  }
}

const DropzoneFieldWrapped = formFieldWrapper((fieldProps, showError) => {
  return <DropzoneField fieldProps={fieldProps} showError={showError} />
})

DropzoneFieldWrapped.propTypes = {
  ...commonPropTypes,
}

export default DropzoneFieldWrapped
